<template>
  <div class="list-wrapper" style="clear:both">
    <span v-for="culture in cultures" :key="culture.id">
      <div style="clear:both">
        <div style="width:5%;float:left">
          <label style="display:inline;">{{ culture.description }}</label>
        </div>
        <div style="width:95%;float:left">
          <div style="width:20%;float:left">
            <MDinput
              v-model="priceValues[culture.id]"
              type="currency"
              :precision="2"
              currency-prefix=""
              clearable
              @input="handlePriceInput($event, culture)"
            />
          </div>
          <div style="width:75%;float:left; margin-left: 10px">
            <el-select
              v-model="currencyValues[culture.id]"
              class="search-select"
              type="select"
              @change="handleCurrencyInput($event, culture)"
            >
              <el-option-group v-if="currencies.length" :label="$t('priceListItemPrice.currency')">
                <el-option
                  v-for="currency in currencies"
                  :key="currency.id"
                  :label="currency.description + ' (' + currency.symbol + ')'"
                  :value="currency.id"
                />
              </el-option-group>
            </el-select>
          </div>
        </div>
      </div>
    </span>
  </div>
</template>

<script>
import MDinput from '@/components/MDinput';

export default {
  components: { MDinput },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    domainID: {
      type: Number
    }
  },
  data() {
    return {
      priceValues: [],
      currencyValues: []
    };
  },
  computed: {
    currencies() {
      return this.$store.getters['currency/loadedItems'];
    },
    cultures() {
      return this.$store.getters['culture/loadedItems'];
    }
  },
  watch: {
    value(newValue) {
      this.priceValues = [];
      this.currencyValues = [];
      if (newValue) {
        newValue.forEach(culturePrice => {
          this.$set(this.priceValues, culturePrice.cultureID, culturePrice.price);
          this.$set(this.currencyValues, culturePrice.cultureID, culturePrice.currencyID);
        });
      }
    },
    domainID(domainID) {
      this.$store.dispatch('culture/getItems', { query: { domainID: domainID } });
    }
  },
  methods: {
    handlePriceInput(price, culture) {
      const newValue = this.value;
      const culturePrice = newValue.find(e => e.cultureID === culture.id);
      if (culturePrice) {
        culturePrice.price = price;
      } else {
        newValue.push({
          cultureID: culture.id,
          price: price
        });
      }
      this.$emit('input', newValue);
      this.$emit('change', this.value);
    },
    handleCurrencyInput(currencyID, culture) {
      const newValue = this.value;
      const culturePrice = newValue.find(e => e.cultureID === culture.id);
      if (culturePrice) {
        culturePrice.currencyID = currencyID;
      } else {
        newValue.push({
          cultureID: culture.id,
          currencyID: currencyID
        });
      }
      this.$emit('input', newValue);
      this.$emit('change', this.value);
    }
  }
};
</script>
